import { Directive, ElementRef, HostListener, Input } from '@angular/core';

function getWindow(): any {
  return window;
}

@Directive({
    selector: '[openLinkInNewWindow]',
    standalone: true
})
export class OpenLinkInNewWindowDirective {
  // @Input('olinwLink') link: string; //intro a new attribute, if independent from routerLink
  // tslint:disable-next-line: no-input-rename
  @Input('routerLink') link: string;
  constructor(private el: ElementRef) {
  }
  @HostListener('mousedown') onMouseEnter() {
    getWindow().open(this.link || '');
  }
}
